// extracted by mini-css-extract-plugin
export default {"container":"ChatJoinPage_container__34-Hx","title":"ChatJoinPage_title__wYXQ2"};